import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import { FiEyeOff } from "react-icons/fi";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { MdOutlineLockPerson } from "react-icons/md";
import { TbCloudDownload } from "react-icons/tb";
import { RxGlobe } from "react-icons/rx";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";

type Props = {
  onAddNew: any;
  getActionOptions: any;
  rows: any;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const TeamResourceListing = ({
  onAddNew,
  rows,
  getActionOptions,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <SideNavLayout>
      <div className="flex flex-col gap-6 p-4 ">
        {/* Page Header */}
        <div className="">
          <ATMPageHeader
            pageTitle="Team Resources"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: onAddNew,
            }}
          />
        </div>

        <div className="grid grid-cols-6 gap-6 mt-3">
          {isCheckActionsPermission({
            moduleName: UserModuleNameTypes.RESOURCE,
            actionName: UserModuleActionTypes.LIST,
          }) && isTableLoading
            ? Array(6)
                .fill(0)
                .map((_, index) => {
                  return (
                    <div key={index} className="animate-pulse  h-[150px] p-2">
                      <div className="h-full rounded bg-slate-200"> </div>
                    </div>
                  );
                })
            : rows?.length
            ? rows?.map((el: any, ind: any) => {
                const options = getActionOptions(el?._id);
                const fileType = el?.fileType;
                return (
                  <div
                    key={ind}
                    className="px-2 border-2 rounded border-slate-200"
                  >
                    <div className="flex justify-between">
                      <p className="font-bold">{el?.title}</p>
                      <div className="flex items-center justify-end">
                        <div className="flex gap-3">
                          <a
                            href={`${el?.fileUrl}`}
                            download="any"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <TbCloudDownload
                              size={20}
                              className="text-slate-600"
                              title="Download"
                            />
                          </a>

                          <div key={el.visibility}>
                            {el.visibility === "ONLY ME" ? (
                              <FiEyeOff
                                size={20}
                                className="text-slate-600"
                                title="This reource is showing only to you"
                              />
                            ) : el.visibility === "PUBLIC" ? (
                              <RxGlobe
                                size={20}
                                className="text-slate-600"
                                title="This resource is public"
                              />
                            ) : (
                              <MdOutlineLockPerson
                                size={20}
                                className="text-slate-600"
                                title={`This resource shared with ${el?.sharedWithUserIds.length} users`}
                              />
                            )}
                          </div>
                        </div>
                        {el.canedit === true ? (
                          <div>
                            <ATMMenu iconSize={20} options={options} />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {fileType === "IMAGE" ? (
                      <div className="py-8">
                        <div className="h-40 w-60">
                          <img
                            className="h-36 w-96"
                            src={el?.fileUrl}
                            alt={el?.title}
                          />
                        </div>
                      </div>
                    ) : fileType === "PDF" ? (
                      <div className="py-8">
                        <div className="flex items-center justify-center py-8 border-2 border-dashed w-60 h-36">
                          <img
                            className="w-16 h-16"
                            src="pdfImage.png"
                            alt="any"
                          />
                        </div>
                      </div>
                    ) : fileType === "EXCEL" ? (
                      <div className="py-8">
                        <div className="flex items-center justify-center py-8 border-2 border-dashed w-60 h-36">
                          <img
                            className="w-16 h-16"
                            src="https://us.123rf.com/450wm/mariia24/mariia242105/mariia24210500063/169021685-computer-software-file-icon-with-initial-name-vector-illustration-isolated-on-white-background.jpg?ver=6"
                            alt="any"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="py-8">
                        <div className="flex items-center justify-center py-8 border-2 border-dashed w-60 h-36">
                          <img
                            className="w-16 h-16"
                            src="https://us.123rf.com/450wm/mariia24/mariia242105/mariia24210500063/169021685-computer-software-file-icon-with-initial-name-vector-illustration-isolated-on-white-background.jpg?ver=6"
                            alt="any"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            : null}
        </div>
      </div>
      <div className="flex justify-end p-4 py-2">
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </SideNavLayout>
  );
};

export default TeamResourceListing;
